// 약관 뷰어/기능 타입
export enum TermsType {
    HTML_VIEWER = 'htmlViewer', // htmlContents 약관 뷰어
    HTML_EXPLAIN = 'htmlExplain', // (PMS3.0 등록 약관) html 약관 뷰어
    PDF_VIEWER = 'pdfViewer', // (PMS3.0 등록 약관) pdf 약관 뷰어
    // PDF_DOWNLOAD = 'pdfDownload', // TODO: (미사용) (PMS3.0 등록 약관) pdf 약관 다운로드
    PDF_PRODUCT = 'pdfProduct', // (PMS2.0 등록 상품) PDF 약관 뷰어
    NO_TERMS = 'noTerms', // 약관없는 약관 케이스 처리
}

// 약관 언어코드
export enum TermsLangCode {
    KOREAN = 'LN1001',
    ENGLISH = 'LN1002',
}

// 상품약관 상품종류
export enum TermsPrdctPrvsnType {
    DEPOSIT = 'DPST', // 수신
    LOAN = 'LOAN', // 여신
    TRUST = 'TRUST', // 신탁
    CARD = 'CARD', // 카드
    INSURANCE = 'INSRNC', // 보험
    ETC_FIX = 'ETC_FIX', // 기타(PMS 2.0 미등록 상품)
}

// 약관 PDF 뷰어 종류
export enum TermsPdfViewerType {
    NATIVE = 'N', // 네이티브
    EMBED = 'E', // PDF embed 팝업
}
